var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-detailed-project-view',{attrs:{"title":"A Simplified Canteen","source":require('@/Resources/Videos/ASimplifiedCanteen.mp4'),"text":_vm.formattedText}})}
var staticRenderFns = []

export { render, staticRenderFns }